/* global swal moment */
import './style.less';
import editJotFormTemplate from 'modals/editJotForm/template.html';
import createJotFormController from 'modals/createJotForm';
import editJotFormController from 'modals/editJotForm';

export default function($log, $stateParams, $q, $timeout, $uibModal, ApiClass, ProfileClass, UserClass, Swal) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  const { company_id } = ProfileClass.profileComplete.profile;
  const isAdmin = UserClass.admin;

  vm.company_id = company_id;

  vm.addJotForm = () => {
    $uibModal
      .open({
        template: editJotFormTemplate,
        backdrop: true,
        windowClass: 'modal',
        controller: createJotFormController,
        controllerAs: 'editJotFormCtrl'
      })
      .result.then(
        success => {
          if (success === 'added') {
            activate();
            Swal.toast('Form added');
          }
        },
        error => {
          if (error === 'backdrop click') return;
          $log.error(error);
          throw error;
        }
      );
  };

  vm.deleteJotForm = type_id => {
    Swal.confirm(
      'Delete form',
      "Are you sure you want to delete the form from Prolaera? JotForm data is stored in JotForm. You can always re-add the form to Prolaera with the form's JotForm ID."
    )
      .then(() => {
        ApiClass.companiesIdTypeTypeIdDelete({
          manage: true,
          id: company_id,
          type: 'forms',
          type_id
        })
          .then(() => {
            activate();
            Swal.toast('Form deleted');
          })
          .catch(error => {
            $log.error(error);
            throw error;
          });
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.editJotForm = uuid => {
    $uibModal
      .open({
        template: editJotFormTemplate,
        backdrop: true,
        windowClass: 'modal',
        controller: editJotFormController(uuid),
        controllerAs: 'editJotFormCtrl'
      })
      .result.then(
        success => {
          if (success === 'updated') {
            activate();
            Swal.toast('Form updated');
          }
        },
        error => {
          if (error === 'backdrop click') return;
          $log.error(error);
          throw error;
        }
      );
  };

  function activate() {
    $log.debug('USER FORMS LOADED');
    vm.loaded = false;
    vm.error = {};
    vm.isAdmin = isAdmin;

    ApiClass.companiesIdTypeGet({ id: company_id, type: 'forms', manage: isAdmin })
      .then(({ data: { items } }) => {
        vm.forms = items;
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/forms/get/index.js